// @flow

import React from 'react';
import Bell  from 'components/common/reminder/bell';

type Props = {
    shake: any,
    dropProcessed: Function,
    component: any,
    translate: Function,
    variant: string,
    orderId: any
};

const Reminder = ({ shake, dropProcessed, component, translate, variant, orderId } : Props) => (
    <div className="js-reminder-container">
        {/* One container serves every width, so there is exactly one
            #reminder-modal on Overblik and one piece of state behind it. */}
        {variant === 'strip' && <div className="modal fade reminder-modal" id="reminder-modal" role="dialog" aria-labelledby="myModalLabel">
            <div className={`modal-dialog`} role="document">
                <div className="modal-content reminder--modal-box">
                    <div className="modal-header pull-right reminder--close">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    {component}
                    </div>
                </div>
            </div>
        </div>}
        {variant === 'strip' && <div className="action-strip--cell action-strip--reminder">
            <Bell shake={shake} />
            <div className="action-strip--texts">
                <strong>{translate('reminder.is_nothing')}</strong>
                <span>{translate('reminder.strip_subtitle')}</span>
            </div>
            <button
                type="button"
                className="btn btn-warning btn-remind"
                data-toggle="modal"
                data-target="#reminder-modal"
                onClick={() => {
                    dropProcessed();
                    if( window.dataLayer ) {
                        window.dataLayer.push({ event: 'minside_reminder_strip_click', order_id: orderId });
                    }
                }}>
                {translate('reminder.send')}
            </button>
        </div>}
    </div>
);

export default Reminder;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/index.js